import { Link } from 'react-router-dom';
import type { BreadcrumbItem } from '@/utils/breadcrumb';

export default function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑" className="mb-5">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-ink-600">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-1">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-600">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'font-bold text-primary-700' : ''}>{item.label}</span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-ink-700" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}